import React, { useState, useEffect, useRef } from 'react';
import { SdfButton, SdfDatePicker, SdfGrid, SdfIcon, SdfInput, SdfSelect, SdfxPagination } from '@synerg/react-components';
import { AgGridReact } from 'ag-grid-react';
import { values } from 'lodash';
import { ListPlaceHolder } from '../../common/placeholder';
import { ColorList } from './colors';
import ExportUsage from './exportUsage';
import { get, orderBy } from 'lodash';
import moment from 'moment-timezone';

const getDateInYearMonth = (date) => {
  const check = moment(date, 'YYYY/MM/DD');
  const month = check.format('MM');
  const year = check.format('YYYY');
  return year + month;
};

const monthDiff = (dateFrom, dateTo) => {
  return dateTo.getMonth() - dateFrom.getMonth() +
    (12 * (dateTo.getFullYear() - dateFrom.getFullYear()));
};

export default function UsageByVerticalAndVerifier(props) {
  const { data = [], getApiUsageData, timelineNumber, loading = false, partnerOOID } = props;
  const [searchName, setSearchName] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [highestVolume, setHighestVolume] = useState(0);
  const [selectedMonthData, setSelectedMonthData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDateString, setSelectedDateString] = useState();
  const [openModal, setOpenModal] = useState(false);
  const open = () => setOpenModal(true);
  const close = () => setOpenModal(false);
  const [start, setStart] = useState(1);
  const [end, setEnd] = useState(10);
  const pagination = [{ label: 5, value: 5 }, { label: 20, value: 20 }, { label: 40, value: 40 }, { label: 60, value: 60 }, { label: 80, value: 80 }, { label: 100, value: 100 }];
  const [total, setTotal] = useState(data.length);
  const [sortOrder, setSortOrder] = useState({ colId: 'volume', sortBy: -1 });
  const grid = useRef();

  useEffect(() => {
    if (data.length > 0) {
      const sortedDataWithColor = dataWithColor(data);
      const filteredData = getDataBySelectedYearAndMonth(selectedDateString);
      updateStartAndEnd(filteredData.length, pageNo, pageSize);
      const map = new Map(sortedDataWithColor.map((vertical) => [vertical.industry, vertical]));
      let updatedData = filteredData.map((vertical) => ({ ...vertical, color: map.get(vertical.industry).color }));
      const highestVolumeRecord = updatedData.reduce((prev, current) => (parseInt(prev.volume) > parseInt(current.volume)) ? prev : current, 0);
      const highestVolume = highestVolumeRecord.volume;
      setHighestVolume(highestVolume);
      setSelectedMonthData(updatedData);
      updatedData = orderBy(updatedData, [x => (x[sortOrder['colId']])], [sortOrder['sortBy']]);
      setFilteredData(updatedData.slice((pageNo - 1) * pageSize, pageNo * pageSize))
      setTotal(updatedData.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, selectedDateString]);

  const updateStartAndEnd = (total, pageNo, pageSize) => {
    setStart(total > 0 ? (pageNo - 1) * pageSize + 1 : 0);
    setEnd((pageNo * pageSize) > total ? total : (pageNo * pageSize));
  };

  useEffect(() => {
    let searchResult = selectedMonthData.filter(({ client, industry, volume }) => {
      if (client && client.toLowerCase().includes(searchName.toLowerCase())) {
        return true;
      }
      else if (industry && industry.toLowerCase().includes(searchName.toLowerCase())) {
        return true;
      } else if (volume && volume.toString().includes(searchName)) {
        return true;
      } else {
        return false;
      }
    });
    searchResult = orderBy(searchResult, [x => (x[sortOrder['colId']])], [sortOrder['sortBy']]);
    setFilteredData(searchResult.slice((pageNo - 1) * pageSize, pageNo * pageSize));
    setTotal(searchResult.length);
    updateStartAndEnd(searchResult.length, pageNo, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize, searchName, sortOrder]);

  const onChangeDate = (date) => {
    setSelectedDate(date);
    const year_month = getDateInYearMonth(date);
    setSelectedDateString(year_month);
    if (monthDiff(new Date(date), new Date()) > timelineNumber) {
			getApiUsageData(monthDiff(new Date(date), new Date()));
		}
  };

  const dataWithColor = (data) => {
    const dataByMonthAndYear = data.reduce((acc, vertical) => {
      if (vertical.year_month === selectedDateString) {
        if (acc[vertical.industry]) {
          acc[vertical.industry].volume += vertical.volume;
        } else {
          acc[vertical.industry] = { ...vertical };
        }
      }
      return acc;
    }, {});
    const sortedData = values(dataByMonthAndYear).sort((a, b) => {
      return b.volume - a.volume;
    });
    const sortedDataWithColor = sortedData.map((vertical, index) => {
      if (index !== 0 && (index % ColorList.length === 0) && (sortedData.length === ColorList.length + 1)) {
        return { ...vertical, color: ColorList[(index + 1) % ColorList.length] };
      } else {
        return { ...vertical, color: ColorList[index % ColorList.length] };
      }
    });

    return sortedDataWithColor;
  };

  const getDataBySelectedYearAndMonth = (yearMonth) => {
    const filteredData = data.reduce((acc, record) => {
      if (record.year_month === yearMonth) {
        acc.push(record);
      }
      return acc;
    }, []);
    return filteredData;
  };

  const myIcons = {
    first: "<sdf-icon icon='nav-page-first' />",
    previous: "<sdf-icon icon='nav-page-back' />",
    next: "<sdf-icon icon='nav-page-next' />",
    last: "<sdf-icon icon='nav-page-last' />",
    sortAscending: "<sdf-icon icon='action-sort-asc' />",
    sortDescending: "<sdf-icon icon='action-sort-desc' />",
    sortUnSort: "<sdf-icon icon='action-sort' />"
  };

  const renderVolumeBar = ({ volume, color }) => {
    return (
      <div className='flex items-center'>
        <div style={{ width: `${volume / highestVolume * 100}%`, background: color, height: '30px', color: 'black' }} >
        </div>
        <div className='ml-1'>{volume.toLocaleString()}</div>
      </div>
    )
  }

  const columnDefs = [
    {
      field: 'client',
      headerName: 'Verifier',
      suppressMovable: true,
      flex: 1,
      sortable: true,
    },
    {
      field: 'industry',
      headerName: 'Vertical',
      suppressMovable: true,
      sortable: true,
      flex: 1,
    },
    {
      field: 'volume',
      headerName: 'API Calls',
      suppressMovable: true,
      flex: 3,
      sortable: true,
      cellRenderer: ({ data }) => renderVolumeBar(data),
    },
  ];

  return (
    <div className='api-usage'>
      {loading
        ? <ListPlaceHolder hasTitle={false} hasIcon={false} filtersNumber={1} />
        : <div className='p-5'>
          <div className='flex justify-between items-center'>
            <div className='title-section mt-2'>
              <div className='text-heading-05 font-bold'>
                API Usage
              </div>
              <div className='text-heading-02 font-bold'>
                By verifier and vertical
              </div>
            </div>
            <div className='flex items-center gap-4'>
              <SdfInput
                size='sm'
                placeholder={'Search by name'}
                value={searchName}
                onSdfInput={({ detail }) => {
                  setSearchName(detail);
                  setPageNo(1);
                }}
              >
                <SdfIcon slot={'after'} icon={'action-search'}></SdfIcon>
              </SdfInput>
              <SdfDatePicker
                className="flex"
                value={selectedDate}
                onSdfChange={({ detail }) => onChangeDate(detail)}
                dateFormat='short'
                rules={[{
                  type: "DISABLED",
                  startDateInclusive: new Date().setDate(1)
                }]}
              />
              <SdfButton className='mt-2' variant='contained' emphasis='primary' onClick={open}>Export</SdfButton>
            </div>
          </div>
          {!loading && data.length > 0 && filteredData && filteredData.length > 0 ?
            <div>
              <SdfGrid className='ag-theme-alpine'>
                <AgGridReact
                  ref={grid}
                  overlayNoRowsTemplate={'No certificates found.'}
                  rowHeight={54}
                  headerHeight={54}
                  domLayout='autoHeight'
                  rowData={filteredData}
                  rowClass='pt-1 cursor-pointer'
                  autoSizeAllColumns={true}
                  icons={myIcons}
                  unSortIcon={true}
                  columnDefs={columnDefs}
                  onSortChanged={($event) => {
                    try {
                      const cols = get(grid, 'current.columnApi.columnModel.gridColumns', []);
                      const sortObj = cols.map((elem) => {
                        if (elem.hasOwnProperty('sort') && elem.hasOwnProperty('colId')) {
                          if (elem.sort !== undefined) {
                            return { colId: elem.colId, sortBy: elem.sort }
                          }
                        }
                        return null;
                      }).filter(elem => elem !== null);
                      if (sortObj.length > 0) {
                        if (sortObj[0].sortBy !== null) {
                          setPageNo(1);
                          setSortOrder({ colId: sortObj[0].colId, sortBy: sortObj[0].sortBy });
                        }
                      }
                    } catch (e) { }
                  }}
                >

                </AgGridReact>
              </SdfGrid>
              <div className='flex items-center justify-end pt-4 pb-20'>
                <div className='text-sm text-action-default'>Rows per page:</div>
                <SdfSelect
                  className='w-20 text-sm text-action-default px-4 mb-1 border-r-1 border-t-0 border-l-0 border-b-0 border-dark border-solid'
                  label="rows per page"
                  hideLabel={true}
                  items={pagination}
                  onSdfChange={({ detail }) => {
                    setPageSize(detail.value);
                  }}
                  value={{ label: `${pageSize}`, value: pageSize }}
                />
                <div className='text-sm text-action-default px-4'>{`${start} - ${end} items`}</div>
                <SdfxPagination
                  currentPage={pageNo}
                  totalPages={Math.ceil(total / pageSize)}
                  onSdfxPageChange={({ detail }) => {
                    setPageNo(detail);
                  }}
                />
              </div>
            </div> :
            <div className='flex min-h-md justify-center items-center'>No data available for this month</div>}
        </div>
      }
      <ExportUsage partnerOOID={partnerOOID} openModal={openModal} close={close} />
    </div>
  );
}
